import { Badge } from '@/components/ui/badge';
import { ClipboardList } from 'lucide-react';
import { EmptyState, Pagination, formatLogDetail, logActionLabels } from './shared';

export function LogsTab({ logs, logPage, logPages, setLogPage }) {
  if (logs.length === 0) return <EmptyState icon={ClipboardList} text="Aucune activite enregistree" />;

  return (
    <div className="space-y-4">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b dark:border-neutral-700 text-left text-xs text-neutral-500 uppercase tracking-wide">
              <th className="pb-3 pr-4">Date</th>
              <th className="pb-3 pr-4">Action</th>
              <th className="pb-3 pr-4">Admin</th>
              <th className="pb-3">Details</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log, i) => (
              <tr key={i} className="border-b dark:border-neutral-700/50 hover:bg-neutral-50 dark:hover:bg-neutral-800" data-testid={`log-row-${i}`}>
                <td className="py-3 pr-4 text-xs text-neutral-500 whitespace-nowrap">{log.created_at ? new Date(log.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '-'}</td>
                <td className="py-3 pr-4"><Badge className="text-[10px] bg-[#1F3F72]/10 text-[#1F3F72] dark:bg-[#1F3F72]/30 dark:text-blue-300">{logActionLabels[log.action] || log.action}</Badge></td>
                <td className="py-3 pr-4 text-xs text-neutral-600 dark:text-neutral-400">{log.admin_email}</td>
                <td className="py-3 text-xs text-neutral-700 dark:text-neutral-300 max-w-md">{formatLogDetail(log.action, log.details, log.target_id)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={logPage} pages={logPages} onPageChange={setLogPage} testId="logs" />
    </div>
  );
}
